import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { AlertTriangle, RefreshCw } from 'lucide-react'
import { FeatureFlags } from '@/config'

export const MaintenanceMode: React.FC = () => {
  if (!FeatureFlags.isInMaintenanceMode()) return null
  
  const handleRefresh = () => {
    window.location.reload()
  }
  
  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full border-orange-200 bg-orange-50 dark:bg-orange-950/20 dark:border-orange-800">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <AlertTriangle className="h-12 w-12 text-orange-600 dark:text-orange-400" />
          </div>
          <CardTitle className="text-orange-800 dark:text-orange-200">
            System Maintenance
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-orange-700 dark:text-orange-300">
            We're currently performing system maintenance to improve your experience. 
            The fraud detection system will be back online shortly.
          </p>
          
          <div className="space-y-2">
            <p className="text-sm text-orange-600 dark:text-orange-400">
              • Enhanced pattern detection algorithms
            </p>
            <p className="text-sm text-orange-600 dark:text-orange-400">
              • Performance improvements
            </p>
            <p className="text-sm text-orange-600 dark:text-orange-400">
              • Security updates
            </p>
          </div>
          
          <Button 
            onClick={handleRefresh}
            variant="outline"
            className="border-orange-300 text-orange-700 hover:bg-orange-100 dark:border-orange-700 dark:text-orange-300 dark:hover:bg-orange-900/20"
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Check Again
          </Button>
          
          <p className="text-xs text-orange-600 dark:text-orange-400">
            Expected completion: 15-30 minutes
          </p>
        </CardContent>
      </Card>
    </div>
  )
}